import findRewardContentStyleSga from './findRewardContentStyleSga';
import findRewardContentStyleDefault from './findRewardContentStyleDefault';
import findRewardContentStyleJamul from './findRewardContentStyleJamul';
import generateRender from 'shared/utils/generateRender';

const findRewardContentStyle = generateRender({
  default: findRewardContentStyleDefault,
  jamul: findRewardContentStyleJamul,
  sga: findRewardContentStyleSga,
});

export default findRewardContentStyle;

export const isSmallerScreenHeight = window.innerHeight < 320;

